var map = {
	"./Features-Block-Reviews-DA-DK-D.avif": 37646,
	"./Features-Block-Reviews-DE-DE-D.avif": 94518,
	"./Features-Block-Reviews-EN-GB-D.avif": 81403,
	"./Features-Block-Reviews-EN-US-D.avif": 77722,
	"./Features-Block-Reviews-ES-ES-D.avif": 25297,
	"./Features-Block-Reviews-ES-MX-D.avif": 4481,
	"./Features-Block-Reviews-FR-FR-D.avif": 23211,
	"./Features-Block-Reviews-IT-IT-D.avif": 91070,
	"./Features-Block-Reviews-NB-NO-D.avif": 72351,
	"./Features-Block-Reviews-NL-NL-D.avif": 91441,
	"./Features-Block-Reviews-PL-PL-D.avif": 18504,
	"./Features-Block-Reviews-PT-BR-D.avif": 33313,
	"./Features-Block-Reviews-PT-PT-D.avif": 91923,
	"./Features-Block-Reviews-SV-SE-D.avif": 86784
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 98977;